//almacena informacion sobre categorias de filtros y filtros
let getFiltros = function() {
  return {
    jornadas: {
      filtros: ["MANANA", "TARDE", "COMPLETA"],
      imagen: "clock",
      valor: "filtrosJornada",
      showIcon: true,
      checkbox: true
    },
    genero: {
      filtros: ["MIXTO", "MUJERES", "HOMBRES"],
      imagen: "restroom",
      valor: "filtrosGenero",
      showIcon: true,
      checkbox: false
    },
    programa: {
      filtros: ["CON_PIE", "SIN_PIE"],
      imagen: "PIE",
      showIcon: false,
      valor: "filtrosPrograma",
      checkbox: false
    },
    dependencia: {
      filtros: ["PUBLICO", "PARTICULAR_SUBVENCIONADO"],
      imagen: "chalkboard-teacher",
      showIcon: true,
      valor: "filtrosDependencia",
      checkbox: false
    },
    otros: {
      filtros: [
        //FILTROS COMENTADOS POR ELIMINACION O REUBICACION
        //"PIE",
        //"ALTA_EXIGENCIA",
        "GRATUITO",
        "INTERNADO",
        "SEP",
        "TECNICO_PROFESIONAL",
        "_4MEDIO"
      ],
      imagen: "filter",
      showIcon: true,
      valor: "filtrosOtros",
      checkbox: true
    }
  };
};

//obtiene tipo del filtro entregado
let getTipoFiltro = function(filtro) {
  let filtros = getFiltros();
  for (let key in filtros) {
    if (filtros[key].filtros.indexOf(filtro) > -1) {
      return key;
    }
  }
};

//traduce un dato categoria para visualizacion en frontend
let traducirCategoria = function(categoria) {
  switch (categoria) {
    case "dependencia":
      return "Dependencia";
    case "jornadas":
      return "Jornada";
    case "genero":
      return "Género";
    case "otros":
      return "Otros criterios";
    case "programa":
      return "Programa Integración Escolar";
    default:
      return categoria;
  }
};

//traduce un dato filtro para visualizacion en frontend
let traducirFiltro = function(filtro) {
  switch (filtro) {
    case "PUBLICO":
      return "Público";
    case "PARTICULAR_SUBVENCIONADO":
      return "Particular Subvencionado";
    case "MANANA":
      return "Mañana";
    case "TARDE":
      return "Tarde";
    case "COMPLETA":
      return "Completa";
    case "MIXTO":
      return "Mixto";
    case "MUJERES":
      return "Sólo Mujeres";
    case "HOMBRES":
      return "Sólo Hombres";
    case "PIE":
      return "Establecimientos con PIE";
    case "GRATUITO":
      return "Establecimientos gratuitos";
    case "INTERNADO":
      return "Establecimientos con internado";
    case "SEP":
      return "Establecimientos adscritos a SEP";
    //case "ALTA_EXIGENCIA":
    //  return "Establecimientos Alta Exigencia";
    case "CON_PIE":
      return "Con Programa de Integración Escolar";
    case "SIN_PIE":
      return "Sin Programa de Integración Escolar";
    case "TECNICO_PROFESIONAL":
      return "Establecimientos TP";
    case "_4MEDIO":
      return "Establecimientos hasta 4° medio";
    default:
      return filtro;
  }
};

export default {
  getFiltros,
  traducirCategoria,
  traducirFiltro,
  getTipoFiltro
};



// WEBPACK FOOTER //
// ./src/utils/Filtros.js